var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpArrowUpBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97715 3.3082C8.85994 3.19102 8.70099 3.12519 8.53525 3.12519C8.36951 3.12519 8.21056 3.19102 8.09336 3.3082L4.99961 6.40195L1.90586 3.3082C1.78741 3.19793 1.6308 3.13791 1.469 3.14075C1.30719 3.1436 1.1528 3.2091 1.0383 3.32347C0.923804 3.43784 0.858134 3.59216 0.855106 3.75397C0.852079 3.91577 0.91193 4.07244 1.02207 4.19101L4.55722 7.72714C4.67443 7.84433 4.83338 7.91016 4.99912 7.91016C5.16486 7.91016 5.32381 7.84433 5.44101 7.72714L8.97715 4.19199C9.09433 4.07478 9.16016 3.91583 9.16016 3.75009C9.16016 3.58436 9.09433 3.42541 8.97715 3.3082Z",
    fill: "#DFD8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10 10) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpArrowUpBold);
export default __webpack_public_path__ + "static/media/ep_arrow-up-bold.aa36715e0703023a821c69a9f767fa5f.svg";
export { ForwardRef as ReactComponent };